<template>
  <v-layout
    column
    text-center
    align-center
    justify-center
    class="sm6 offset-sm3 flex"
  >
    <p class="display-1 mt-12 primary--text">
      Thank you for signing up! Please follow the link we sent to your email to
      activate your account and you're good to go
    </p>
    <p class="subtitle-1">Feel free to close this tab now, or</p>
    <v-btn text color="accent" width="200" @click="resend" :loading="sending"
      >Resend activation link</v-btn
    >
  </v-layout>
</template>

<script>
export default {
  data: () => ({
    sending: false,
  }),
  methods: {
    resend() {
      this.sending = true;
      this.$store.state.axios
        .post("api/auth/ResendVerification")
        .finally(() => (this.sending = false));
    },
  },
};
</script>
